import { EXPRESS_API } from 'configs/api/expressApi';
import { useInfiniteQuery, useQuery } from 'react-query';
import { superAdminKeys } from './superAdminKeys';
import { DEFAULT_UI_KITS_SIZE } from 'app/pages/admin/landing-pages-v2/components/uikit/UIKit';
import { errorToast } from 'lib/components/toasts/error';

export interface IResseler {
  resellerId: number;
  resellerName: string;
  url: string;
  email: string;
  phoneNumber: string;
  pls: number;
  customerId: number | null;
  playbackUrl: string;
  integration: number;
  fullReportAccess: number;
  easyCare: number;
  dealer: number;
  resellerReportingEnabled: number;
}

export const getResellers = async (
  search: string = '',
  start: number = 0,
  limit: number,
  resellerSortOrder?: string,
  resellerSortKey?: string
) => {
  const params = {
    search,
    start,
    limit,
    resellerSortOrder,
    resellerSortKey,
    active: 1,
  };

  return (
    await EXPRESS_API.get(`superadmin/resellers`, {
      params,
    })
  ).data as [IResseler[], number];
};

interface IResellersParams {
  search: string;
  start?: number;
  limit: number;
  enabled: boolean;
}

export const useGetResellers = ({
  search,
  start,
  limit,
  enabled,
}: IResellersParams) => {
  return useQuery(
    superAdminKeys.reseller(),
    () => getResellers(search, start, limit),
    {
      refetchOnMount: true,
      enabled,
    }
  );
};

export const useInfiniteGetResellersQuery = (params: IResellersParams) => {
  return useInfiniteQuery(
    superAdminKeys.infinite_resellers(params),
    ({ pageParam = 0 }) =>
      getResellers(
        params.search,
        pageParam * DEFAULT_UI_KITS_SIZE,
        params.limit
      ),
    {
      refetchOnMount: true,
      getNextPageParam: (_, allPages) => {
        return allPages.length;
      },
      onError: () => {
        errorToast({
          title: "We're currently experiencing difficulties fetching resellers",
        });
      },
    }
  );
};
